import { gqlTypes } from '../types/gqlTypes';
import { ageInMonths } from './petUtils';
import { domainConfig } from './domainConfig';

const shopProductPath = (productType: 'collar' | 'mini') => {
  if (productType === 'collar') {
    return 'smart-collar-v3b';
  }
  if (productType === 'mini') {
    return 'fi-mini';
  }
};

export interface ShopPetInfo {
  name: string;
  gender: gqlTypes.Gender;
  yearOfBirth: number;
  monthOfBirth?: number | null;
  dayOfBirth?: number | null;
  weight: number;
  breed?: { __typename?: 'Breed'; id: string; name: string } | null;
  species?: gqlTypes.Species | null;
}

/**
 * Adds the pet personalization query params the shop reads. Appends to any existing query string,
 * so it is safe on links we did not build - notably the api-signed GWA landing page, whose `fi_c`
 * token must survive.
 */
export const appendPetParams = (shopUrl: string, petInfo: ShopPetInfo) => {
  const url = new URL(shopUrl);
  url.searchParams.append('pet_name', petInfo.name);
  url.searchParams.append('pet_weight', Math.round(petInfo.weight).toString());
  url.searchParams.append('pet_breed', petInfo.breed?.name || '');
  url.searchParams.append('pet_gender', petInfo.gender.toLowerCase());
  url.searchParams.append(
    'pet_age',
    ageInMonths(petInfo.yearOfBirth, petInfo.monthOfBirth || 0, petInfo.dayOfBirth || 0).toString(),
  );
  // shop reads species as `type`, and only understands dog/cat. omit it for OTHER so shop
  // falls back to its own default rather than being told the wrong species.
  if (petInfo.species === gqlTypes.Species.DOG || petInfo.species === gqlTypes.Species.CAT) {
    url.searchParams.append('type', petInfo.species.toLowerCase());
  }
  return url.toString();
};

export const getShopURL = (source: string, petInfo: ShopPetInfo, productType: 'collar' | 'mini' = 'collar') => {
  const url = new URL(
    domainConfig.shopProductsUrl +
      shopProductPath(productType) +
      '?utm_campaign=PP_Nano&utm_medium=Nano&utm_source=Web',
  );
  url.searchParams.append('utm_content', source);
  if (!petInfo) {
    return url.toString();
  }
  return appendPetParams(url.toString(), petInfo);
};
